export default __webpack_public_path__ + "static/media/green-bond-principles.46652102.jpg";